import { JUDGE_IS_LOGIN } from '@store/officialWebStore/login';
import {
  GET_SEPC_GAME_INFO,
  GET_LASTED_STORE_ROLE
} from '@store/officialWebStore';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  LOAD_GAME_COUPON_LIST,
  LOAD_VIP_COUPON_INFO
} from '@store/store/coupon';
import { mapGetters } from 'vuex';

export default {
  computed: {
    isOpenCoupon() {
      if (+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenCoupon || false;
    },
    isOpenVip() {
      if (+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenVip || false;
    },
    ...mapGetters(['gameInfoConfig'])
  },
  methods: {
    globalBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
        if (!res) {
          return;
        }
        this.$store.dispatch(GET_LASTED_STORE_ROLE);
        const canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: this.$store.state.gameId
        });
        if (canContinue === false) {
          globalConfig.jumpErrorPage();
          return;
        }
        // 2024-04-09 :修复因接口请求顺序错误，导致登录态异常（这个接口也需要登录态，所以登录成功再请求好了）
        this.isOpenCoupon && this.$store.dispatch(LOAD_GAME_COUPON_LIST);
        this.isOpenVip && this.$store.dispatch(LOAD_VIP_COUPON_INFO);
      });
    },
    jpBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN);
    }
  },
  created() {
    this.$store.getters.isJpPlatform
      ? this.jpBeforeCreate()
      : this.globalBeforeCreate();
  }
};
